const FENCE_LINE_PATTERN = /^ {0,3}(`{3,}|~{3,})(.*)$/

export interface TrailingOpenFence {
  language: string
  openerStart: number
  bodyStart: number | null
}

export interface ClosedFenceSpan {
  start: number
  end: number
}

export interface FenceScan {
  closedSpans: ClosedFenceSpan[]
  trailingOpen: TrailingOpenFence | null
}

interface OpenFence {
  marker: string
  language: string
  openerStart: number
  bodyStart: number | null
}

function closesFence(open: OpenFence, marker: string, infoString: string): boolean {
  return marker[0] === open.marker[0] && marker.length >= open.marker.length && infoString.trim() === ""
}

export function scanFences(content: string): FenceScan {
  const closedSpans: ClosedFenceSpan[] = []
  let open: OpenFence | null = null
  let lineStart = 0
  while (lineStart <= content.length) {
    const newlineAt = content.indexOf("\n", lineStart)
    const lineEnd = newlineAt === -1 ? content.length : newlineAt
    const line = content.slice(lineStart, lineEnd)
    const fenceMatch = FENCE_LINE_PATTERN.exec(line)
    if (fenceMatch) {
      const [, marker, infoString] = fenceMatch
      if (open && closesFence(open, marker, infoString)) {
        closedSpans.push({ start: open.openerStart, end: lineEnd })
        open = null
      } else if (!open) {
        open = {
          marker,
          language: infoString.trim().split(/\s+/)[0] ?? "",
          openerStart: lineStart,
          bodyStart: newlineAt === -1 ? null : newlineAt + 1,
        }
      }
    }
    if (newlineAt === -1) break
    lineStart = newlineAt + 1
  }
  const trailingOpen = open ? { language: open.language, openerStart: open.openerStart, bodyStart: open.bodyStart } : null
  return { closedSpans, trailingOpen }
}

export function findTrailingOpenFence(content: string): TrailingOpenFence | null {
  return scanFences(content).trailingOpen
}
